import React from 'react';
import '../index.css';

function WidgetHeader({toggleState}){
    return (<>
        <div className="container-header">
            <h2>Accessibility Menu</h2>
            <a href="javascript:;" onClick={toggleState} className="widget-close-btn" aria-label="Press enter to Close the accessibility menu">
                <span className="focus-outline"></span>
            </a>
        </div> 
    </>);

}

export default WidgetHeader;